// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hyzB","title":"Info_title__3fBfr","selects":"Info_selects__295yq","requiredAsterisk":"Info_requiredAsterisk__14HFd"};